export default __webpack_public_path__ + "static/media/Rectangle 1056.3552beff.png";